if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      const inputEle = this.form.querySelector('[name=id]')
      inputEle.disabled = false;
      
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

      //custom product options
      this.assemblyOption = this.form.querySelector("#assembly-option");
      this.nameOption = this.form.querySelector("#naming-option");
      this.customFields = this.form.querySelectorAll(".personalization-field");
      this.maxNameLength = 15;

      this.cartNotification = document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if(QCM_PRODUCT && QCM_PRODUCT.options && QCM_PRODUCT.options.length){
        this.submitButton.disabled = "disabled";
        inputEle.value = "";
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.error = false;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      if(this.nameOption){
        const validName = this.isNameValid(this.nameOption.value);
        if(!validName){
          this.handleErrorMessage(`Please enter a name between 1 and ${this.maxNameLength} characters long`);
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.error = false;
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');      
          return;
        }
      }

      if(this.customFields){
        for(const field of this.customFields){
          if(!field.required) continue;
          if(field.value.length > 0) continue;

          this.handleErrorMessage(`Please ensure all fields marked with an asterisk are filled`);
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.error = false;
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');    
          return;     
        }
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.error = true;

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;

            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cartNotification.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
          this.submitButton.removeAttribute('aria-disabled');
          this.error = false;
        })
        .finally(() => {

          if(this.assemblyOption && this.assemblyOption.checked && !this.error){
            this.addAssemblyProductToCart();
            return;
          }

          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.error = false;
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          window.shopifyCartClient.refreshCart();
        });         
    }

    isNameValid(name) {
      if(name.length <= this.maxNameLength 
        && name.length > 0){
        return true;
      }

      return false;
    }

    addAssemblyProductToCart() {
      const assemblyATCData = {
        'items': [{
         'id': 43118037991583,
         'quantity': 1
         }]
       };

      // add assembly item for applicable products when selected
      if(this.assemblyOption && this.assemblyOption.checked){
        fetch(`${routes.cart_add_url}`, {
          method: "POST", 
          headers: {
            'Content-Type': 'application/json'
          },            
          body: JSON.stringify(assemblyATCData)
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
        })
        .catch((e) => {
          console.error(e);
          this.submitButton.removeAttribute('aria-disabled');
          this.error = false;
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.error = false;
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          window.shopifyCartClient.refreshCart();
        });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
